import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import PersonAddIcon from '@mui/icons-material/PersonAddAltOutlined'
import { colors } from '../../const/colors'
import { CARD_SX, SectionHeader } from './UserDetailsUi'

const AssignToServiceAction: FC<{
  canAssign: boolean
  assignHint: string
  onAssign: () => void
  step: number
}> = ({ canAssign, assignHint, onAssign, step }) => {
  const { t } = useTranslation(['parking_pool', 'btn'])

  return (
    <Box sx={CARD_SX}>
      <SectionHeader
        icon={<PersonAddIcon sx={{ fontSize: 18 }} />}
        title={t('parking_pool:assign_to_service')}
        step={step}
        mb="12px"
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          mb: '14px',
          color: colors.textMuted,
          lineHeight: 1.4,
        }}
      >
        {!canAssign && (
          <ErrorOutlineIcon
            sx={{ fontSize: 15, color: colors.slate, flexShrink: 0 }}
          />
        )}
        <Typography
          sx={{ fontSize: '12.5px', fontWeight: 600 }}
          data-e2e="assign-hint"
        >
          {canAssign ? t('parking_pool:assign_ready') : assignHint}
        </Typography>
      </Box>
      <Box
        onClick={() => canAssign && onAssign()}
        data-e2e="assign-to-service"
        aria-disabled={!canAssign}
        sx={{
          height: 52,
          borderRadius: '13px',
          fontSize: '14.5px',
          fontWeight: 800,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          transition: 'background .15s',
          ...(canAssign
            ? {
                background: colors.navy,
                color: '#fff',
                cursor: 'pointer',
                boxShadow: colors.shadowBtn,
                '&:hover': { background: colors.navyDark },
              }
            : {
                background: colors.bg,
                color: colors.slateLight,
                cursor: 'not-allowed',
              }),
        }}
      >
        {canAssign && <CheckIcon sx={{ fontSize: 18 }} />}
        {t('parking_pool:assign_to_service')}
      </Box>
    </Box>
  )
}

export default AssignToServiceAction
